import { doSVGsupportCheck, doWebGLSupportCheck } from './support.js'

window.onload = function() {
  doSVGsupportCheck();
  doWebGLSupportCheck();
};
